<template>
  <ModalMobileDefault modal_id="menuMobileModal"
                      header=""
                      size="modal-xl modal-dialog-scrollable"
                      style_header=""
                      modal_header=""
                      footer=""
                      class_body="px-0 pt-0 pb-0 bg-light"
                      icon="">
    <div class="px-0 pt-0 pb-0 h-100" slot="body">
      <div class="col-12 d-flex px-3 py-4 justify-content-between">
        <div class="pl-3 pt-1">
          Menu
        </div>
        <div class="pr-2">
          <i data-dismiss="modal" class="bx bx-x bx-sm"></i>
        </div>
      </div>
      <div class="col-12 px-4">
        <ul class="list-group ellipsis" style="min-width: 100%;">

          <router-link :to="{ name: 'Home' }"
                       data-dismiss="modal"
                       :class="{'list_hover_active' : this.$route.name === 'Home'}"
                       class="list-group-item list_hover cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis">{{ getTranslations('expression_11') }}</span>
            <i v-if="this.$route.name === 'Home'"
               class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </router-link>

          <router-link :to="{ name: 'Channels' }"
                       data-dismiss="modal"
                       :class="{'list_hover_active' : this.$route.name === 'Channels' || this.$route.name === 'Channel'}"
                       class="list-group-item list_hover cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis">{{ getTranslations('expression_5') }}</span>
            <i v-if="this.$route.name === 'Channels' || this.$route.name === 'Channel'"
               class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </router-link>

          <router-link :to="{ name: 'Chat' }"
                       data-dismiss="modal"
                       :class="{'list_hover_active' : this.$route.name === 'Chat'}"
                       class="list-group-item list_hover cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis">{{ getTranslations('expression_312') }}</span>
            <i v-if="this.$route.name === 'Chat'"
               class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </router-link>

          <router-link :to="{ name: 'Leads' }"
                       data-dismiss="modal"
                       :class="{'list_hover_active' : this.$route.name === 'Leads' || this.$route.name === 'Lead'}"
                       class="list-group-item list_hover cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis">{{ getTranslations('expression_35') }}</span>
            <i v-if="this.$route.name === 'Leads' || this.$route.name === 'Lead'"
               class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </router-link>

          <router-link :to="{ name: 'Users' }"
                       data-dismiss="modal"
                       :class="{'list_hover_active' : this.$route.name === 'Users' || this.$route.name === 'Users'}"
                       class="list-group-item list_hover cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis">{{ getTranslations('expression_82') }}</span>
            <i v-if="this.$route.name === 'Users' || this.$route.name === 'Users'"
               class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </router-link>

          <router-link :to="{ name: 'Campaigns' }"
                       data-dismiss="modal"
                       :class="{'list_hover_active' : this.$route.name === 'Campaigns' || this.$route.name === 'Campaign'}"
                       class="list-group-item list_hover cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis">{{ getTranslations('expression_3') }}</span>
            <i v-if="this.$route.name === 'Campaigns' || this.$route.name === 'Campaign'"
               class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </router-link>

          <router-link :to="{ name: 'ReportsTickets' }"
                       data-dismiss="modal"
                       :class="{'list_hover_active' : this.$route.name === 'Reports' || this.$route.name === 'ReportsTickets' }"
                       class="list-group-item list_hover cursor_pointer d-flex justify-content-between text-decoration-none">
            <span class="ellipsis">{{ getTranslations('expression_59') }}</span>
            <i v-if="this.$route.name === 'Reports' || this.$route.name === 'ReportsTickets'"
               class="animated--grow-in bx bx-chevron-right bx-xs"></i>
          </router-link>
        </ul>
      </div>
    </div>
  </ModalMobileDefault>
</template>

<script>
import ModalMobileDefault from "../../components/general/ModalMobileDefault";
import {mapGetters} from "vuex";

export default {
  name: "ModalMenuMobile",
  components: {
    ModalMobileDefault,
  },
  methods: {},
  computed: {
    ...mapGetters([])
  }
}
</script>

<style scoped>

</style>
